import { Link } from 'react-router-dom'
import { AccountRecord } from '../../../../api/client'

type Props = {
    account: AccountRecord
}

export default function ShadowBanningSettingsReadOnly(props: Props) {
    const { account } = props

    if (account.shadowBanningEnabled) {
        return (
            <div>
                <div className="inline-flex items-center gap-1.5 bg-green-50 text-green-700 px-2.5 py-1 rounded-full text-xs font-semibold uppercase tracking-wide mb-3">
                    <span className="w-1.5 h-1.5 bg-green-700 rounded-full"></span>
                    Enabled
                </div>{' '}
                <br />
                If a commenter posts more than{' '}
                <strong>
                    {String(account.shadowBanningThreshold)} severe comments
                </strong> within <strong>{String(account.shadowBanningRangeInDays)} days</strong>{' '}
                they will be shadow banned and all subsequent comments auto-hidden.
                <Link
                    to={`/account/${account.id}/settings/shadow-banning`}
                    className="font-semibold text-primary-600 hover:text-primary-500"
                >
                    Click here to edit these settings
                </Link>
            </div>
        )
    } else {
        return (
            <div>
                <span className="inline-flex items-center gap-1.5 bg-red-50 text-red-700 px-2.5 py-1 rounded-full text-xs font-semibold uppercase tracking-wide mb-3">
                    <span className="w-1.5 h-1.5 bg-red-700 rounded-full"></span>
                    Disabled
                </span>
                <br />
                <Link
                    to={`/account/${account.id}/settings/shadow-banning`}
                    className="font-semibold text-primary-600 hover:text-primary-500"
                >
                    Click here to enable shadow banning.
                </Link>
            </div>
        )
    }
}
